import React, { useState, useEffect, useContext, useRef } from "react";
import { View, Text, Linking, StyleSheet, Dimensions, FlatList, Image, TextInput, Pressable, ImageBackground, Input, Modal, ScrollView, Alert } from "react-native";
import { Ionicons } from '@expo/vector-icons';
import { getFirestore, collection, query, where, getDoc, getDocs, doc, updateDoc, arrayUnion, setDoc, arrayRemove } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useUser } from "../Widgets/UserContext";
import ECardSelectionModal from "../Screens/RegistryWidgets/eCards";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import Checkout from "../Screens/RegistryWidgets/Checkout";
import ContributionFlow from "../Screens/RegistryWidgets/ContributionFlow";
import { ConnectedAccountModal, ConnectedAccount } from "../Screens/PaymentProcessing/ConnectedAccount";
import { useBackground } from '../Screens/Helpers/BackgroundContext';
import Catalogue from "../Screens/RegistryWidgets/Catalogue";
import { useNavigation, useFocusEffect } from "@react-navigation/native";
import { useTutorial, TutorialPopup } from "../Screens/Helpers/Tutorials";
import { stripeConfigService } from '../services/StripeConfigService';
import ContactCaptureService from '../services/ContactCaptureService';
import SharedModal from './SharedModal';
import QRCodeShare from './QRCodeShare';

import exampleBackground1 from "../assets/exBackground1.jpg";
import exampleBackground2 from "../assets/exBackground2.jpg";
import exampleBackground3 from "../assets/exBackground3.jpg";
import exampleBackground4 from "../assets/exBackground4.jpg";
import exampleBackground5 from "../assets/exBackground5.jpg";
import exampleBackground6 from "../assets/exBackground6.jpg";
import exampleBackground7 from "../assets/exBackground7.jpg";
import genericProfilePic from "../assets/generic.jpg";
import logo from "../assets/logo.png"; // Import the logo
import { SERVER_URL } from '../config.js'; // Use centralized config
import { MYTASSEL_PLUS_FEATURES } from '../constants/MyTasselPlus';
import useMyTasselPlus from '../Hooks/useMyTasselPlus';
import { getMyTasselPublicUrls } from '../services/VanitySlugService';
import { hasEstablishedGoalTarget, UNSET_GOAL_TARGET } from '../utils/gradFundGoal';
import GradFundGoalEditor from './GradFundGoalEditor';
import GradFundGoalOnboarding from './GradFundGoalOnboarding';
import { spotlightTarget, SPOTLIGHT_TARGETS } from './SpotlightTutorial/spotlightTargets';
import { emitSpotlightEvent, useEmitSpotlightEventWhenOpened } from './SpotlightTutorial/spotlightBus';
import { SPOTLIGHT_EVENTS } from './SpotlightTutorial/spotlightEventNames';

// Helper to get base URL based on current environment
const getBaseUrl = () => {
	if (typeof window === 'undefined') return 'https://mytassel.com';
	const hostname = window.location?.hostname;
	if (hostname === 'mytassel.com' || hostname === 'www.mytassel.com') {
		return 'https://mytassel.com';
	}
	// For localhost, staging, or any other environment, use current origin
	return window.location?.origin || 'https://mytassel.com';
};

const { width, height } = Dimensions.get('window');
const isMobile = width < 768;
const isTablet = width >= 768 && width < 1024;
const isSmallDesktop = width >= 1024 && width < 1440;
const isLargeDesktop = width >= 1440;

// Helper to get eventId from URL
const getEventId = () => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname;
    const search = window.location.search;
    // Only match if path is exactly /events/G06785 and there are NO query params
    if (path === '/events/G06785' && (!search || search === '')) {
      return 'G06785';
    }
  }
  return null;
};

const CombinedCard = ({ pageOwnerId, pageOwner, isVisitorView, isPreviewMode = false }) => {
   const navigation = useNavigation();
   const { backgroundImage } = useBackground();
   const { width } = Dimensions.get('window');
   const isMobile = width < 768;
   const db = getFirestore();
   const { currentUser, currentUserData } = useUser();
   const myTasselPlus = useMyTasselPlus();
   const [messages, setMessages] = useState([]);
   const [goalData, setGoalData] = useState({});
   const [shouldHideDefaultGoalTarget, setShouldHideDefaultGoalTarget] = useState(false);
   const [message, setMessage] = useState("");
   const [signature, setSignature] = useState({ firstName: "", lastName: "" });
   const [image, setImage] = useState(null); // State to store the uploaded image
   const [activeTab, setActiveTab] = useState("Yearbook");
   useEmitSpotlightEventWhenOpened(activeTab === "GoalTracker", SPOTLIGHT_EVENTS.ANNOUNCEMENT_FUND_OPENED);
   useEmitSpotlightEventWhenOpened(activeTab === "Share", SPOTLIGHT_EVENTS.ANNOUNCEMENT_SHARE_OPENED);
   const [profilePictures, setProfilePictures] = useState({});
   const [showEditGoal, setShowEditGoal] = useState(false);
   const [showContribution, setShowContribution] = useState(false);
   const [contributionAmount, setContributionAmount] = useState("");
   const [showECardModal, setShowECardModal] = useState(false);
   const [showCheckoutModal, setShowCheckoutModal] = useState(false);
   const [selectedECard, setSelectedECard] = useState(null);
   const [showConnectedAccountModal, setShowConnectedAccountModal] = useState(false);

   const [showShareForm, setShowShareForm] = useState(false);
   const [recipientEmails, setRecipientEmails] = useState("");
   const [loading, setLoading] = useState(false); // State to manage loading
   const [error, setError] = useState(""); // State to manage error messages
   const [goalImage, setGoalImage] = useState(null); // State to store the uploaded goal image
   const [uploadStatus, setUploadStatus] = useState({ loading: false, error: "", success: "" });
   const [showCatalogueModal, setShowCatalogueModal] = useState(false);
   const [showEmailWarning, setShowEmailWarning] = useState(false);
   const [stripePromise, setStripePromise] = useState(null);
   const [showContributionFlow, setShowContributionFlow] = useState(false);
   const publicUrls = getMyTasselPublicUrls({ pageOwner, pageOwnerId, baseUrl: getBaseUrl() });
	const {
		setShowTutorial,
		setActivePopupId,
		showTutorial,
		isLoading,
		tutorialsToShow,
		setClosedTutorials,
		setTutorialsToShow
	} = useTutorial();

   const [recipientType, setRecipientType] = useState("email");
   const [phoneNumbers, setPhoneNumbers] = useState("");
   const [isError, setIsError] = useState(false);
   const [isSharing, setIsSharing] = useState(false);
   const [isShared, setIsShared] = useState(false);
   const [qrCodeValue, setQrCodeValue] = useState("");
   const [activeShareTab, setActiveShareTab] = useState("email"); // 'email', 'phone', or 'qr'

   // Session and edit/delete state for yearbook messages
   const [sessionId, setSessionId] = useState(null);
   const [editingMessage, setEditingMessage] = useState(null);
   const [editText, setEditText] = useState("");
   const [editImage, setEditImage] = useState(null);
   const [showEditModal, setShowEditModal] = useState(false);
   const [showDeleteModal, setShowDeleteModal] = useState(false);
   const [messageToDelete, setMessageToDelete] = useState(null);
   // Reply modal state to match Yearbook functionality
   const [showReplyModal, setShowReplyModal] = useState(false);
   const [messageToReply, setMessageToReply] = useState(null);
   const [replyText, setReplyText] = useState("");
   // Actions menu state (use same UX as registry Yearbook)
   const [showActionsFor, setShowActionsFor] = useState(null);
   const [actionsMenuData, setActionsMenuData] = useState(null);
   const [actionsMenuPosition, setActionsMenuPosition] = useState(null);
   const messageRefs = useRef({});
   const scrollViewRef = useRef();

   const eventId = getEventId();
   const isSampleEvent = eventId === 'G06785';
   const contactCaptureService = new ContactCaptureService();
   const goalTargetAmount = Number(goalData.targetAmount) || 0;
   const goalAmountContributed = Number(goalData.amountContributed) || 0;
   const hasEstablishedGoal = !shouldHideDefaultGoalTarget && hasEstablishedGoalTarget(goalData);
   const hasCompletedStripeSetup = Boolean(pageOwner?.stripeAccountId && pageOwner?.stripeSetupComplete);
   const isCurrentPageOwner = pageOwnerId === currentUserData?.uid;
   const showGoalOnboarding = isCurrentPageOwner && !isVisitorView && !hasEstablishedGoal;
   const progressPercent = hasEstablishedGoal && goalTargetAmount > 0
      ? Math.min((goalAmountContributed / goalTargetAmount) * 100, 100)
      : 0;

   // Session management for anonymous users
   const generateSessionId = () => {
      return 'session-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
   };

   const getOrCreateSessionId = () => {
      try {
         let stored = localStorage.getItem('yearbookSessionId');
         if (!stored) { stored = generateSessionId(); localStorage.setItem('yearbookSessionId', stored); }
         return stored;
      } catch (e) {
         return generateSessionId();
      }
   };

   const generateMessageId = () => {
      return 'msg-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
   };

   // Check if current user can edit/delete a message
   const canEditMessage = (messageData) => {
      // Page owner can edit/delete any message on their yearbook
      if (currentUserData?.uid === pageOwnerId) {
         return true;
      }
      
      // For logged in users - check if they own the message
      if (currentUserData?.uid && 
          (messageData.senderUID === currentUserData.uid || 
           messageData.createdBy === currentUserData.uid)) {
         return true;
      }
      
      // For anonymous users - check session ID
      if (!currentUserData?.uid && messageData.sessionId === sessionId && messageData.senderUID === 'anonymous') {
         return true;
      }
      
      return false;
   };
   
   // Check if current user is the page owner
   const isPageOwner = () => {
      return currentUserData?.uid === pageOwnerId;
   };

   useEffect(() => {
      // Initialize session for anonymous users
      const currentSessionId = getOrCreateSessionId();
      setSessionId(currentSessionId);
      loadMessages();
      loadGoalData();
   }, [pageOwnerId]);

   useEffect(() => {
      if (scrollViewRef.current && messages.length > 0) {
         setTimeout(() => {
            try { scrollViewRef.current.scrollToEnd({ animated: true }); } catch (e) {}
         }, 120);
      }
   }, [messages]);

   useEffect(() => {
      messages.forEach((message) => {
         if (message.senderUID && !profilePictures[message.senderUID]) {
            fetchProfilePictureUrl(message.senderUID);
         }
      });
   }, [messages]);

   // Initialize Stripe with dynamic key from configuration service
   useEffect(() => {
      const initializeStripe = async () => {
         try {
            const stripeKey = await stripeConfigService.getPublishableKey();
            if (stripeKey) {
               const stripe = loadStripe(stripeKey);
               setStripePromise(stripe);
            }
         } catch (error) {
            
         }
      };

      initializeStripe();

      // Listen for configuration changes and reinitialize
      const unsubscribe = stripeConfigService.addChangeListener(() => {
         
         initializeStripe();
      });

      return unsubscribe; // Cleanup listener on unmount
   }, []);

   const loadMessages = async () => {
      // Always fetch from Firestore
      const q = query(collection(db, "users"), where("uid", "==", pageOwnerId));
      const querySnapshot = await getDocs(q);
      let dbMessages = [];
      if (!querySnapshot.empty) {
         querySnapshot.forEach(async (docSnapshot) => {
            const data = docSnapshot.data();
            const rawMessages = data.messages?.yearbookMessages || [];
            
            // Add IDs to messages that don't have them (for backwards compatibility)
            let messagesUpdated = false;
            const messagesWithIds = rawMessages.map(msg => {
               if (!msg.id) {
                  messagesUpdated = true;
                  return {
                     ...msg,
                     id: generateMessageId(),
                     createdBy: msg.senderUID || 'unknown',
                  };
               }
               return {
                  ...msg,
                  createdBy: msg.createdBy || msg.senderUID || 'unknown',
               };
            });
            
            // Update the database with IDs if needed
            if (messagesUpdated && !isPreviewMode) {
               try {
                  const userDocRef = doc(db, "users", docSnapshot.id);
                  await updateDoc(userDocRef, {
                     "messages.yearbookMessages": messagesWithIds,
                  });
               } catch (error) {
                  
               }
            }
            
            dbMessages = messagesWithIds;
         });
      }
      // Ensure messages are sorted oldest -> newest so newest appears at the bottom
      dbMessages = dbMessages.slice().sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0));

      if (isSampleEvent) {
        // Also load from localStorage
        const local = localStorage.getItem('sampleEventYearbookMessages');
        const localMessages = local ? JSON.parse(local) : [];
        setMessages([...localMessages, ...dbMessages]);
      } else {
        setMessages(dbMessages);
      }
   };

   const loadGoalData = async () => {
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("uid", "==", pageOwnerId));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
         querySnapshot.forEach((docSnap) => {
            const userData = docSnap.data();
            if (userData.pages?.registryPageConfig?.goalTracker) {
               const goalTrackerData = userData.pages.registryPageConfig.goalTracker;
               const loadedTargetAmount = parseFloat(goalTrackerData.targetAmount) || UNSET_GOAL_TARGET;
               setShouldHideDefaultGoalTarget(!hasEstablishedGoalTarget({ ...goalTrackerData, targetAmount: loadedTargetAmount }));
               setGoalData({
                  ...goalTrackerData,
                  amountContributed: parseFloat(goalTrackerData.amountContributed || 0),
                  targetAmount: loadedTargetAmount,
               });
            } else {
               setShouldHideDefaultGoalTarget(true);
               // Initialize with default values
               setGoalData({
                  targetAmount: UNSET_GOAL_TARGET,
                  amountContributed: 0,
                  description: "",
                  title: "",
                  goalPictureURL: "",
                  goalURL: "",
                  accountURLs: [],
                  contributions: [],
               });
            }
         });
      }
   };

   const fetchProfilePictureUrl = async (uid) => {
      if (!uid || profilePictures[uid]) return;
      try {
         // Some user UIDs are stored with different prefixes (F/G/A) while message senderUIDs may be numeric-only.
         // Try to find matching users by common prefixed variants as well as the uid itself.
         const numericPartOfUID = uid.substring(1);
         const usersRef = collection(db, "users");
         const q = query(usersRef, where("uid", "in", [`F${numericPartOfUID}`, `G${numericPartOfUID}`, `A${numericPartOfUID}`, uid]));
         const querySnapshot = await getDocs(q);
         if (!querySnapshot.empty) {
            querySnapshot.forEach((docSnap) => {
               const data = docSnap.data();
               if (data.uid) {
                  setProfilePictures((prevPics) => ({ ...prevPics, [uid]: data.profilePictureURL }));
               }
            });
         }
      } catch (error) {
         // fallback: ignore
      }
   };

   const isMessageFromPageOwner = (msg) => msg && (msg.senderUID === pageOwnerId || msg.createdBy === pageOwnerId);

   const isSenderCurrentViewer = (msg) => {
      if (!msg) return false;
      if (currentUserData?.uid) return msg.senderUID === currentUserData.uid || msg.createdBy === currentUserData.uid;
      return msg.sessionId === sessionId && msg.senderUID === 'anonymous';
   };

   const openActionsMenu = (item) => {
      const ref = messageRefs.current[item.id];
      const setPos = (pageX, pageY, w, h) => {
         setActionsMenuPosition({ x: pageX, y: pageY, width: w, height: h });
         setActionsMenuData(item);
         setShowActionsFor(item.id);
      };
      try {
         if (ref) {
            if (typeof ref.measureInWindow === 'function') {
               ref.measureInWindow((pageX, pageY, w, h) => setPos(pageX, pageY, w, h));
            } else if (typeof ref.measure === 'function') {
               ref.measure((x, y, w, h, pageX, pageY) => setPos(pageX, pageY, w, h));
            } else {
               setActionsMenuData(item);
               setShowActionsFor(item.id);
            }
         } else {
            setActionsMenuData(item);
            setShowActionsFor(item.id);
         }
      } catch (e) {
         setActionsMenuData(item);
         setShowActionsFor(item.id);
      }
   };

   const handleReplyClick = (msg) => {
      setMessageToReply(msg);
      setReplyText('');
      setShowReplyModal(true);
   };

   const handleSendReply = async () => {
      if (!replyText.trim() || !messageToReply) return;
      const newMessage = {
         id: generateMessageId(),
         text: replyText.trim(),
         image: null,
         senderFirstName: currentUserData?.firstName || signature.firstName || 'Anonymous',
         senderLastName: currentUserData?.lastName || signature.lastName || '',
         senderUID: currentUserData?.uid || 'anonymous',
         senderPhotoURL: currentUserData?.photoURL || '',
         timestamp: Date.now(),
         sessionId: sessionId,
         createdBy: currentUserData?.uid || 'anonymous',
         isReply: true,
         replyToId: messageToReply.id || null,
         originalSenderName: `${messageToReply.senderFirstName || ''} ${messageToReply.senderLastName || ''}`.trim(),
         originalMessageText: messageToReply.text || messageToReply.message || ''
      };

      try {
         if (isPreviewMode) {
            setMessages(prev => [...prev, newMessage]);
            setShowReplyModal(false);
            setMessageToReply(null);
            setReplyText('');
            return;
         }

         if (isSampleEvent) {
            const local = localStorage.getItem('sampleEventYearbookMessages');
            const localMessages = local ? JSON.parse(local) : [];
            const updated = [...localMessages, newMessage];
            localStorage.setItem('sampleEventYearbookMessages', JSON.stringify(updated));
            setMessages(prev => [...prev, newMessage]);
            setShowReplyModal(false);
            setMessageToReply(null);
            setReplyText('');
            return;
         }

         const q = query(collection(db, "users"), where("uid", "==", pageOwnerId));
         const querySnapshot = await getDocs(q);
         if (!querySnapshot.empty) {
            querySnapshot.forEach(async (docSnapshot) => {
               await updateDoc(doc(db, "users", docSnapshot.id), { "messages.yearbookMessages": arrayUnion(newMessage) });
            });
         }
         setMessages(prev => [...prev, newMessage]);
         setShowReplyModal(false);
         setMessageToReply(null);
         setReplyText('');
      } catch (e) {
         console.error('Error sending reply', e);
      }
   };

   const formatDate = (timestamp) => {
      if (!timestamp) return '';
      try {
         let d;
         if (timestamp instanceof Date) d = timestamp;
         else if (typeof timestamp.toDate === 'function') d = timestamp.toDate();
         else d = new Date(timestamp);
         return d.toLocaleString();
      } catch (e) { return ''; }
   };

   const handleSend = async () => {
      if (!message.trim() && !image) return;
      const newMessage = {
         id: generateMessageId(),
         text: message.trim(),
         image: image || null,
         senderFirstName: currentUserData?.firstName || signature.firstName.trim() || "Anonymous",
         senderLastName: currentUserData?.lastName || signature.lastName.trim() || "",
         senderUID: currentUserData?.uid || "anonymous",
         senderPhotoURL: currentUserData?.photoURL || "",
         timestamp: Date.now(),
         sessionId: sessionId,
         createdBy: currentUserData?.uid || 'anonymous',
      };
         if (isPreviewMode) {
            setMessages([...messages, newMessage]);
            setMessage("");
            setImage(null);
            setSignature({ firstName: "", lastName: "" });
            return;
         }

         if (isSampleEvent) {
            // Local-only: save to localStorage — append so newest appears at the bottom
            const local = localStorage.getItem('sampleEventYearbookMessages');
            const localMessages = local ? JSON.parse(local) : [];
            const updated = [...localMessages, newMessage];
            setMessages([...messages, newMessage]);
            localStorage.setItem('sampleEventYearbookMessages', JSON.stringify(updated));
            setMessage("");
            setImage(null);
            setSignature({ firstName: "", lastName: "" });
            return;
         }
      try {
         const q = query(collection(db, "users"), where("uid", "==", pageOwnerId));
         const querySnapshot = await getDocs(q);
         if (!querySnapshot.empty) {
            const docSnapshot = querySnapshot.docs[0];
            const userDocRef = doc(db, "users", docSnapshot.id);
            const docData = await getDoc(userDocRef);
            if (docData.exists() && docData.data().messages && docData.data().messages.yearbookMessages) {
               await updateDoc(userDocRef, {
                  "messages.yearbookMessages": arrayUnion(newMessage),
               });
            } else {
               const messagesObj = { yearbookMessages: [newMessage] };
               await setDoc(userDocRef, { messages: messagesObj }, { merge: true });
            }
            setMessage("");
            setImage(null);
            setSignature({ firstName: "", lastName: "" });
            loadMessages();
         }
      } catch (error) {
         console.error("Error saving yearbook message:", error);
      }
      
      // Send email notification to page owner (not to self)
      if (newMessage.senderUID !== pageOwnerId) {
         const emailToUse = pageOwner?.email;
         if (emailToUse) {
            try {
               const senderFullName = `${newMessage.senderFirstName || ''} ${newMessage.senderLastName || ''}`.trim() || 'Someone';
               const graduateFullName = `${pageOwner?.firstName || ''} ${pageOwner?.lastName || ''}`.trim() || 'Graduate';
               
               const response = await fetch(`${SERVER_URL}/send-yearbook-message-notification`, {
                  method: "POST",
                  headers: {
                     "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                     graduateName: graduateFullName,
                     graduateEmail: emailToUse,
                     senderName: senderFullName,
                     senderEmail: currentUserData?.email || '',
                     message: newMessage.text,
                     yearbookUrl: `https://mytassel.com/events/${pageOwner?.uid || ''}`,
                  }),
               });
               if (!response.ok) {
                  console.error('Yearbook notification failed:', await response.text());
               }
            } catch (error) {
               console.error('Yearbook notification error:', error);
            }
         }
      }
   };

   const handleYearbookImageUpload = async (event) => {
      setUploadStatus({ loading: true, error: "", success: "" });
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
         try {
            if (isPreviewMode) {
               const previewUrl = typeof URL !== 'undefined' ? URL.createObjectURL(file) : null;
               if (previewUrl) setImage(previewUrl);
               setUploadStatus({ loading: false, error: "", success: "Image added in preview. Changes are not saved." });
               return;
            }

            const storageRef = ref(getStorage(), `yearbookImages/${file.name}-${Date.now()}`);
            const uploadResult = await uploadBytes(storageRef, file);
            const publicUrl = await getDownloadURL(uploadResult.ref);
            setImage(publicUrl);
            setUploadStatus({ loading: false, error: "", success: "Image uploaded successfully!" });
         } catch (err) {
            
            setUploadStatus({ loading: false, error: "Failed to upload image. Please try again.", success: "" });
         }
      } else {
         setUploadStatus({ loading: false, error: "Please select a valid image file.", success: "" });
      }
   };

   const handleEditMessage = (messageData) => {
      setEditingMessage(messageData);
      setEditText(messageData.text);
      setEditImage(messageData.image);
      setShowEditModal(true);
   };

   const handleUpdateMessage = async () => {
      if (!editingMessage || (!editText.trim() && !editImage)) return;

      const updatedMessage = {
         ...editingMessage,
         text: editText.trim(),
         image: editImage,
         lastEditedAt: Date.now(),
      };

      try {
         if (isPreviewMode) {
            setMessages(currentMessages => currentMessages.map(msg =>
               msg.id === editingMessage.id ? updatedMessage : msg
            ));
            setShowEditModal(false);
            setEditingMessage(null);
            setEditText("");
            setEditImage(null);
            return;
         }

         if (isSampleEvent) {
            // Update localStorage for sample event
            const local = localStorage.getItem('sampleEventYearbookMessages');
            const localMessages = local ? JSON.parse(local) : [];
            const updatedMessages = localMessages.map(msg => 
               msg.id === editingMessage.id ? updatedMessage : msg
            );
            localStorage.setItem('sampleEventYearbookMessages', JSON.stringify(updatedMessages));
            loadMessages();
         } else {
            // Update Firestore
            const q = query(collection(db, "users"), where("uid", "==", pageOwnerId));
            const querySnapshot = await getDocs(q);
            
            if (!querySnapshot.empty) {
               querySnapshot.forEach(async (docSnapshot) => {
                  const userDocRef = doc(db, "users", docSnapshot.id);
                  const docData = await getDoc(userDocRef);
                  
                  if (docData.exists() && docData.data().messages?.yearbookMessages) {
                     const currentMessages = docData.data().messages.yearbookMessages;
                     const updatedMessages = currentMessages.map(msg => 
                        msg.id === editingMessage.id ? updatedMessage : msg
                     );
                     
                     await updateDoc(userDocRef, {
                        "messages.yearbookMessages": updatedMessages,
                     });
                     
                     loadMessages();
                  }
               });
            }
         }
         
         setShowEditModal(false);
         setEditingMessage(null);
         setEditText("");
         setEditImage(null);
      } catch (error) {
         
         Alert.alert("Error", "Failed to update message. Please try again.");
      }
   };

   const handleHideMessage = async (messageData) => {
      try {
         if (isPreviewMode) {
            setMessages(currentMessages => currentMessages.map(msg =>
               msg.id === messageData.id ? { ...msg, hidden: !msg.hidden } : msg
            ));
            return;
         }

         if (isSampleEvent) {
            // Update localStorage for sample event
            const local = localStorage.getItem('sampleEventYearbookMessages');
            const localMessages = local ? JSON.parse(local) : [];
            const updatedMessages = localMessages.map(msg => 
               msg.id === messageData.id 
                  ? { ...msg, hidden: !msg.hidden }
                  : msg
            );
            localStorage.setItem('sampleEventYearbookMessages', JSON.stringify(updatedMessages));
            loadMessages();
         } else {
            // Find and update the message in Firestore
            const q = query(collection(db, "users"), where("uid", "==", pageOwnerId));
            const querySnapshot = await getDocs(q);
            
            if (!querySnapshot.empty) {
               querySnapshot.forEach(async (docSnapshot) => {
                  const userDocRef = doc(db, "users", docSnapshot.id);
                  const docData = await getDoc(userDocRef);
                  
                  if (docData.exists() && docData.data().messages?.yearbookMessages) {
                     const currentMessages = docData.data().messages.yearbookMessages;
                     const updatedMessages = currentMessages.map(msg => 
                        msg.id === messageData.id 
                           ? { ...msg, hidden: !msg.hidden }
                           : msg
                     );
                     
                     await updateDoc(userDocRef, {
                        "messages.yearbookMessages": updatedMessages,
                     });
                     
                     loadMessages();
                  }
               });
            }
         }
      } catch (error) {
         
      }
   };

   const handleDeleteMessage = (messageData) => {
      setMessageToDelete(messageData);
      setShowDeleteModal(true);
   };

   const confirmDeleteMessage = async () => {
      if (!messageToDelete) return;
      
      try {
         if (isPreviewMode) {
            setMessages(currentMessages => currentMessages.filter(msg => msg.id !== messageToDelete.id));
            setShowDeleteModal(false);
            setMessageToDelete(null);
            return;
         }

         if (isSampleEvent) {
            // Update localStorage for sample event
            const local = localStorage.getItem('sampleEventYearbookMessages');
            const localMessages = local ? JSON.parse(local) : [];
            const updatedMessages = localMessages.filter(msg => msg.id !== messageToDelete.id);
            localStorage.setItem('sampleEventYearbookMessages', JSON.stringify(updatedMessages));
            loadMessages();
         } else {
            // Find and remove the message from Firestore
            const q = query(collection(db, "users"), where("uid", "==", pageOwnerId));
            const querySnapshot = await getDocs(q);
            
            if (!querySnapshot.empty) {
               querySnapshot.forEach(async (docSnapshot) => {
                  const userDocRef = doc(db, "users", docSnapshot.id);
                  const docData = await getDoc(userDocRef);
                  
                  if (docData.exists() && docData.data().messages?.yearbookMessages) {
                     const currentMessages = docData.data().messages.yearbookMessages;
                     const updatedMessages = currentMessages.filter(msg => msg.id !== messageToDelete.id);
                     
                     await updateDoc(userDocRef, {
                        "messages.yearbookMessages": updatedMessages,
                     });
                     
                     loadMessages();
                  }
               });
            }
         }
         setShowDeleteModal(false);
         setMessageToDelete(null);
      } catch (error) {
         
         // Could add error state here instead of Alert
      }
   };

   const handleEditImageUpload = async (event) => {
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
         if (isPreviewMode) {
            const previewUrl = typeof URL !== 'undefined' ? URL.createObjectURL(file) : null;
            if (previewUrl) setEditImage(previewUrl);
            return;
         }

         const storageRef = ref(getStorage(), `yearbookImages/${file.name}-${Date.now()}`);
         const uploadResult = await uploadBytes(storageRef, file);
         const publicUrl = await getDownloadURL(uploadResult.ref);
         setEditImage(publicUrl);
      }
   };

   const handleGoalImageUpload = async (event) => {
      setUploadStatus({ loading: true, error: "", success: "" });
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
         if (!myTasselPlus.canUseFeature(MYTASSEL_PLUS_FEATURES.GOAL_IMAGE)) {
            event.target.value = '';
            setUploadStatus({ loading: false, error: "", success: "" });
            myTasselPlus.openUpsell(MYTASSEL_PLUS_FEATURES.GOAL_IMAGE);
            return;
         }

         try {
            if (isPreviewMode) {
               const previewUrl = typeof URL !== 'undefined' ? URL.createObjectURL(file) : null;
               if (previewUrl) {
                  setGoalImage(previewUrl);
                  setGoalData((prevData) => ({ ...prevData, goalPictureURL: previewUrl }));
               }
               setUploadStatus({ loading: false, error: "", success: "Image added in preview. Changes are not saved." });
               return;
            }

            const storageRef = ref(getStorage(), `goalImages/${file.name}-${Date.now()}`);
            const uploadResult = await uploadBytes(storageRef, file);
            const publicUrl = await getDownloadURL(uploadResult.ref);
            setGoalImage(publicUrl);
            setGoalData((prevData) => ({ ...prevData, goalPictureURL: publicUrl })); // Update goalData with new image URL
            setUploadStatus({ loading: false, error: "", success: "Image uploaded successfully!" });
         } catch (err) {
            
            setUploadStatus({ loading: false, error: "Failed to upload image. Please try again.", success: "" });
         }
      } else {
         setUploadStatus({ loading: false, error: "Please select a valid image file.", success: "" });
      }
   };

   const handleContribution = () => {
      setShowContributionFlow(true);
   };

   const handleSaveGoal = async () => {
      if (isPreviewMode) {
         setShowEditGoal(false);
         return;
      }

      const goalToSave = {
         ...goalData,
         targetAmount: shouldHideDefaultGoalTarget ? UNSET_GOAL_TARGET : (parseFloat(goalData.targetAmount) || UNSET_GOAL_TARGET),
      };
      try {
         await updateGoalTrackerFields({ "pages.registryPageConfig.goalTracker": goalToSave });
         setGoalData(goalToSave);
         setShouldHideDefaultGoalTarget(!hasEstablishedGoalTarget(goalToSave));
         setShowEditGoal(false);
      } catch (error) {
         alert("Failed to save your Graduation Fund: " + error.message);
      }
   };

   const handleGoalFieldChange = (field, value) => {
      if (field === "targetAmount") setShouldHideDefaultGoalTarget(false);
      setGoalData((previousGoalData) => ({ ...previousGoalData, [field]: value }));
   };

   const goalPhotoMessage = uploadStatus.loading
      ? { type: "info", text: "Uploading image..." }
      : uploadStatus.error
         ? { type: "error", text: uploadStatus.error }
         : uploadStatus.success
            ? { type: "success", text: uploadStatus.success }
            : null;

   const updateGoalTrackerFields = async (fields) => {
      const q = query(collection(db, "users"), where("uid", "==", pageOwnerId));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.empty) throw new Error("Could not find your account. Please refresh and try again.");
      await Promise.all(querySnapshot.docs.map((docSnapshot) => updateDoc(doc(db, "users", docSnapshot.id), fields)));
   };

   const handleResetTargetAmount = async () => {
      const confirmReset = window.confirm("Reset your Grad Fund target amount? You can set a new one at any time. Funds already received won't be affected.");
      if (!confirmReset) return;

      try {
         if (!isPreviewMode) {
            await updateGoalTrackerFields({ "pages.registryPageConfig.goalTracker.targetAmount": UNSET_GOAL_TARGET });
         }
         setGoalData((previousGoalData) => ({ ...previousGoalData, targetAmount: UNSET_GOAL_TARGET }));
         setShouldHideDefaultGoalTarget(true);
         setShowEditGoal(false);
      } catch (error) {
         alert("Failed to reset your Grad Fund target amount: " + error.message);
      }
   };

   const handleECardSelection = (eCardData) => {
      
      setSelectedECard(eCardData);
      setShowECardModal(false);
      setShowCheckoutModal(true);
      
   };

   const submitContribution = async () => {
      const newAmount = parseFloat(contributionAmount) || 0;
      const updatedAmount = parseFloat(goalData.amountContributed || 0) + newAmount; // Ensure we're working with numbers

      if (isPreviewMode) {
         setGoalData(prev => ({
            ...prev,
            amountContributed: updatedAmount,
            contributions: [
               ...(prev.contributions || []),
               { amount: newAmount, timestamp: new Date().toISOString(), preview: true }
            ]
         }));
         setContributionAmount("");
         setShowContributionFlow(false);
         return;
      }

      const usersRef = collection(db, "users");
      const q = query(usersRef, where("uid", "==", pageOwnerId));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
         querySnapshot.forEach(async (docSnapshot) => {
            const userDocRef = doc(db, "users", docSnapshot.id);
            
            // Update only the amountContributed field
            await updateDoc(userDocRef, {
               "pages.registryPageConfig.goalTracker.amountContributed": updatedAmount
            });
            
            // Add the contribution to the contributions array
            await updateDoc(userDocRef, {
               "pages.registryPageConfig.goalTracker.contributions": arrayUnion({
                  amount: newAmount,
                  contributorName: currentUserData?.firstName + " " + currentUserData?.lastName,
                  contributorId: currentUserData?.uid,
                  timestamp: new Date()
               })
            });
         });
      }

      // Update local state
      setGoalData(prevData => ({
         ...prevData,
         amountContributed: updatedAmount
      }));

      setShowContribution(false);
      setContributionAmount("");
      setShowCheckoutModal(false);
   };

   const handleShare = async () => {
      if (recipientType === "email") {
         setShowEmailWarning(true); // Show warning first
      } else {
         // SMS is coming soon, no action needed
      }
   };

   const handleShareTab = () => {
      setActiveTab("Share");
   };

   const trackShare = async (shareData) => {
      try {
         if (!currentUser || !currentUserData) {
            // If no user is logged in, just proceed without tracking
            return;
         }

         // Determine pageType based on active tab
         const pageType = activeTab.toLowerCase();

         // Use email as document ID and include more user information
         const shareAnalyticsRef = doc(db, "shareAnalytics", currentUserData.email.toLowerCase());
         const shareAnalyticsDoc = await getDoc(shareAnalyticsRef);
         
         const newShare = {
            recipient: shareData.recipients.join(", "),
            date: new Date().toISOString(),
            type: shareData.type,
            sharedPageType: pageType,
            pageOwnerUid: pageOwner.uid,
            senderName: `${currentUserData.firstName} ${currentUserData.lastName}`,
            senderEmail: currentUserData.email.toLowerCase()
         };

         if (shareAnalyticsDoc.exists()) {
            const currentData = shareAnalyticsDoc.data();
            await updateDoc(shareAnalyticsRef, {
               totalShares: (currentData.totalShares || 0) + 1,
               [`${shareData.type}Shares`]: arrayUnion(newShare),
               lastShareDate: new Date().toISOString(),
               userId: currentUser.uid,
               userEmail: currentUserData.email.toLowerCase(),
               firstName: currentUserData.firstName,
               lastName: currentUserData.lastName
            });
         } else {
            await setDoc(shareAnalyticsRef, {
               userId: currentUser.uid,
               userEmail: currentUserData.email.toLowerCase(),
               firstName: currentUserData.firstName,
               lastName: currentUserData.lastName,
               totalShares: 1,
               emailShares: shareData.type === 'email' ? [newShare] : [],
               smsShares: shareData.type === 'sms' ? [newShare] : [],
               lastShareDate: new Date().toISOString()
            });
         }

         
      } catch (error) {
         
      }
   };

   const shareAnnouncementPage = async () => {
      setIsSharing(true);
      const emailsArray = recipientEmails.split(",").map(email => email.trim());
      const payload = {
         recipients: emailsArray,
         senderFirstName: pageOwner.firstName,
         senderLastName: pageOwner.lastName,
         uic: pageOwner.uic,
      };

      if (pageOwner.pages.events) {
         payload.eventsPageUrl = publicUrls.events;
      }

      if (pageOwner.pages.registry) {
         payload.registryPageUrl = publicUrls.registry;
      }

      try {
         const response = await fetch(`${SERVER_URL}/share-user-pages`, {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
         });

         const data = await response.json();

         if (response.ok) {
            // Track share analytics
            await trackShare({
               type: 'email',
               recipients: emailsArray
            });

            // Capture contacts for reminder system (all shares)
            try {
               // Get successful email recipients
               const successfulEmails = data.results && data.results.length > 0 
                  ? data.results.map(result => result.email || result.to)
                  : emailsArray;
               
               // Create contact objects
               const contacts = contactCaptureService.createEmailContacts(successfulEmails, 'email_share_combinedcard');
               
               // Save contacts to the page owner's document
               const captureResult = await contactCaptureService.addSharedContacts(pageOwner.uid, contacts);
               
               if (captureResult.success) {
                  console.log('Contacts captured for reminders:', captureResult);
               } else {
                  console.error('Contact capture returned failure:', captureResult);
               }
               
            } catch (contactError) {
               console.error('Contact capture failed:', contactError);
            }

            if (data.errors && data.errors.length > 0) {
               if (data.results && data.results.length > 0) {
                  setIsShared(true);
                  setError(`${data.results.length} email(s) sent successfully, but ${data.errors.length} failed. Please check the email addresses and try again for the failed ones.`);
               } else {
                  setError("Failed to send any emails. Please check the addresses and try again.");
               }
               setIsError(true);
            } else {
               setIsShared(true);
               setIsError(false);
               setError("");
               setRecipientEmails("");
            }
         } else {
            setError(data.error || "Failed to send invitations. Please try again.");
            setIsError(true);
         }
      } catch (error) {
         
         setError("An error occurred while sending invitations. Please try again.");
         setIsError(true);
      } finally {
         setIsSharing(false);
      }
   };

   const handleRegistryPress = () => {
      if (pageOwner.pages.registry) {
         const urlParams = new URLSearchParams(window.location.search);
         const uic = urlParams.get('uic');

         // Use environment-aware base URL instead of stored production URL
         let registryUrl = publicUrls.registry;
         if (uic) {
            registryUrl += `?uic=${uic}`; // Append the UIC to the registry URL
         }

         Linking.openURL(registryUrl);
         emitSpotlightEvent(SPOTLIGHT_EVENTS.ANNOUNCEMENT_REGISTRY_OPENED);
      } else {
         setActiveTab("Registry");
      }
   };

   const shareViaSMS = async (phoneList) => {
      try {
         // Basic phone number validation before sending
         const validPhoneList = phoneList.filter(phone => {
            const cleaned = phone.replace(/\D/g, '');
            return cleaned.length >= 10 && cleaned.length <= 11;
         });

         if (validPhoneList.length === 0) {
            setError("Please enter valid phone numbers (e.g., 123-456-7890)");
            setIsError(true);
            return;
         }

         const response = await fetch(`${SERVER_URL}/share-via-sms`, {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
            },
            body: JSON.stringify({
               recipients: validPhoneList,
               senderFirstName: pageOwner.firstName,
               senderLastName: pageOwner.lastName,
               eventsPageUrl: publicUrls.events,
               registryPageUrl: publicUrls.registry,
               uic: pageOwner.uic,
            }),
         });

         const data = await response.json();

         if (response.ok) {
            // Track share analytics
            await trackShare({
               type: 'sms',
               recipients: validPhoneList
            });

            // Capture phone contacts for reminder system (all shares)
            try {
               // Get successful phone recipients
               const successfulPhones = data.results && data.results.length > 0 
                  ? data.results.map(result => result.phone || result.to)
                  : validPhoneList;
               
               // Create contact objects
               const contacts = contactCaptureService.createPhoneContacts(successfulPhones, 'sms_share_combinedcard');
               
               // Save contacts to the page owner's document
               const captureResult = await contactCaptureService.addSharedContacts(pageOwner.uid, contacts);
               
               if (captureResult.success) {
                  console.log('SMS contacts captured for reminders:', captureResult);
               } else {
                  console.error('SMS contact capture returned failure:', captureResult);
               }
               
            } catch (contactError) {
               console.error('SMS contact capture failed:', contactError);
            }

            if (data.errors && data.errors.length > 0) {
               if (data.results && data.results.length > 0) {
                  setIsShared(true);
                  setError(`${data.results.length} message(s) sent successfully, but ${data.errors.length} failed. Please check the phone numbers and try again for the failed ones.`);
               } else {
                  setError("Failed to send messages. Please check the phone numbers and try again.");
               }
               setIsError(true);
            } else {
               setIsShared(true);
               setIsError(false);
               setError("");
               setPhoneNumbers("");
            }
         } else {
            setError(data.error || "Failed to send SMS invitations. Please try again.");
            setIsError(true);
         }
      } catch (error) {
         
         setError("An error occurred while sending invitations. Please try again.");
         setIsError(true);
      }
   };

   function generateQrCodeUrl() {
      // Generate a random string or UUID for the QR code
      const randomStr = Math.random().toString(36).substring(2, 10) + Date.now();
      const separator = publicUrls.events.includes('?') ? '&' : '?';
      return `${publicUrls.events}${pageOwner?.uic ? `${separator}uic=${pageOwner.uic}` : ''}${pageOwner?.uic ? '&' : separator}qr=${randomStr}`;
   }

   return (
      <View {...spotlightTarget(SPOTLIGHT_TARGETS.ANNOUNCEMENT_YEARBOOK)} style={[
         styles.container
      ]}>
         <View style={[
            styles.innerContainer,
            {
               flex: 1,
               minHeight: 0,
               height: 'auto',
               overflow: 'visible',
               alignSelf: 'stretch',
               boxSizing: 'border-box',
               position: 'relative',
            }
         ]}>
            <View style={styles.tabContainer}>
               <View style={styles.tabWithDot}>
                  <View style={styles.tabDotWrapper}>
                     <View style={{ height: 24 }} />
                     <TutorialPopup id="combinedCardYearbook" title="Yearbook" openDirection="topLeft" style={styles.tutorialDotAbsolute} />
                     <Pressable
                        style={[styles.tabButton, activeTab === "Yearbook" && styles.activeTabButton]}
                        onPress={() => setActiveTab("Yearbook")}
                     >
                        <Text style={activeTab === "Yearbook" ? styles.activeTabButtonText : styles.tabButtonText}>{pageOwner?.firstName}'s Yearbook</Text>
                     </Pressable>
                  </View>
               </View>
               <View style={styles.tabWithDot}>
                  <View style={styles.tabDotWrapper}>
                     <View style={{ height: 24 }} />
                     <TutorialPopup id="combinedCardGoalTracker" title="Graduation Fund" openDirection="topLeft" style={styles.tutorialDotAbsolute} />
                     <Pressable
                        {...spotlightTarget(SPOTLIGHT_TARGETS.ANNOUNCEMENT_FUND_TAB)}
                        style={[styles.tabButton, activeTab === "GoalTracker" && styles.activeTabButton]}
                        onPress={() => setActiveTab("GoalTracker")}
                     >
                        <Text style={activeTab === "GoalTracker" ? styles.activeTabButtonText : styles.tabButtonText}>Graduation Fund</Text>
                     </Pressable>
                  </View>
               </View>
               <View style={styles.tabWithDot}>
                  <View style={styles.tabDotWrapper}>
                     <View style={{ height: 24 }} />
                     <TutorialPopup id="combinedCardRegistry" title="Registry" openDirection="topLeft" style={styles.tutorialDotAbsolute} />
                     <Pressable
                        {...spotlightTarget(SPOTLIGHT_TARGETS.ANNOUNCEMENT_REGISTRY_TAB)}
                        style={[styles.tabButton, activeTab === "Registry" && styles.activeTabButton]}
                        onPress={handleRegistryPress}
                     >
                        <Text style={activeTab === "Registry" ? styles.activeTabButtonText : styles.tabButtonText}>{pageOwner?.firstName}'s Registry</Text>
                     </Pressable>
                  </View>
               </View>
               <View style={styles.tabWithDot}>
                  <View style={styles.tabDotWrapper}>
                     <View style={{ height: 24 }} />
                     <TutorialPopup id="combinedCardShare" title="Share" openDirection="topLeft" style={styles.tutorialDotAbsolute} />
                     <Pressable
                        {...spotlightTarget(SPOTLIGHT_TARGETS.ANNOUNCEMENT_SHARE_TAB)}
                        style={[styles.tabButton, activeTab === "Share" && styles.activeTabButton]}
                        onPress={handleShareTab}
                     >
                        <Text style={activeTab === "Share" ? styles.activeTabButtonText : styles.tabButtonText}>Share</Text>
                     </Pressable>
                  </View>
               </View>
            </View>

            {activeTab === "Yearbook" && (
               <ImageBackground
                  source={{ uri: backgroundImage }}
                  style={styles.yearbookBackground}
                  imageStyle={styles.yearbookImage}
               >
                  <View style={styles.yearbookContainer}>
                     <ScrollView style={styles.messagesContainer} showsVerticalScrollIndicator={true}>

                        {messages.map((msg, index) => {
                           const canEdit = canEditMessage(msg);
                           const isHidden = msg.hidden && !(isPageOwner() || (isSenderCurrentViewer(msg)));
                           const isHiddenForOwner = msg.hidden && isPageOwner();
                           const isSenderViewer = isSenderCurrentViewer(msg);
                           const profilePicUrl = isSenderViewer ? null : (msg.senderPhotoURL || profilePictures[msg.senderUID] || genericProfilePic);
                           
                           // Don't render hidden messages for non-owners
                           if (isHidden) return null;
                           
                           return (
                              <React.Fragment key={msg.id || index}>
                                {/* If this message is a reply, render the original message reference outside the message bubble (matches Registry yearbook) */}
                                {msg.isReply && (
                                  <View style={[styles.replyReference, isSenderViewer ? styles.replyReferenceRight : styles.replyReferenceLeft]}>
                                    <Text style={styles.replyReferenceText}>Replying to {msg.originalSenderName}</Text>
                                    <Text style={styles.replyOriginalText}>{msg.originalMessageText}</Text>
                                  </View>
                                )}

                                <View
                                   ref={ref => { if (ref && msg.id) messageRefs.current[msg.id] = ref; }}
                                   style={[
                                      styles.message,
                                      isSenderViewer ? styles.currentUserMessage : styles.otherUserMessage,
                                      isHiddenForOwner && styles.hiddenMessageContainer,
                                      msg.isReply && styles.replyMessage,
                                   ]}
                                >
                                   {profilePicUrl ? <Image source={{ uri: profilePicUrl }} style={[styles.profileImage, isHiddenForOwner && styles.hiddenImage]} /> : null}
                                   <View style={[styles.messageContent, isHiddenForOwner && styles.hiddenMessage]}>
                                      <View style={styles.messageHeader}>
                                         <Text style={[styles.messageSender, !isSenderViewer && styles.otherUserText, isHiddenForOwner && styles.hiddenText]}>
                                            {isSenderViewer ? 'You' : `${msg.senderFirstName || ''} ${msg.senderLastName || ''}`}{isHiddenForOwner ? ' (Hidden)' : ''}
                                         </Text>
                                         {canEdit && (
                                            <Pressable onPress={() => openActionsMenu(msg)} style={{ padding: 6 }}>
                                               <Ionicons name="ellipsis-horizontal" size={18} color="#333" />
                                            </Pressable>
                                         )}
                                      </View>

                                      {msg.image && <Image source={{ uri: msg.image }} style={[styles.messageImage, isHiddenForOwner && styles.hiddenImage]} />}
                                      <Text style={[styles.messageText, !isSenderViewer && styles.otherUserText, isHiddenForOwner && styles.hiddenText]}>{msg.text}</Text>
                                      <View style={styles.timestampContainer}>
                                         <Text style={[styles.messageTimestamp, !isSenderViewer && styles.otherUserText]}>
                                            {formatDate(msg.timestamp)}
                                         </Text>
                                         {msg.lastEditedAt && (
                                            <Text style={[styles.editedTimestamp, !isSenderViewer && styles.otherUserText]}>
                                               (edited)
                                            </Text>
                                         )}
                                      </View>
                                   </View>
                                </View>
                              </React.Fragment>
                           );
                        })}
                        <View style={[styles.message, styles.otherUserMessage, styles.alignLeft]}>
                           <Image source={logo} style={styles.profileImage} />
                           <View style={styles.messageContent}>
                              <Text style={[styles.messageSender, styles.otherUserText]}>The MyTassel Team</Text>
                              <Text style={[styles.messageText, styles.otherUserText]}>
                                 Congratulations on your accomplishment! Your hard work and perseverance paid off! As you share your page, Friends and Family can use this space to share messages, memories, and upload their favorite photos to celebrate YOU!
                              </Text>
                           </View>
                        </View>


                     </ScrollView>
                     <View style={styles.yearbookInputContainer}>
                        <TextInput
                           style={styles.yearbookInput}
                           placeholder="Write a message..."
                           placeholderStyle={styles.yearbookInputPlaceholder}
                           value={message}
                           onChangeText={setMessage}
                        />
                        <Pressable style={styles.uploadButton} onPress={() => document.getElementById('yearbookFileInput').click()}>
                           <Text style={styles.uploadButtonText}>{isMobile ? "Photo" : "Upload Photo"}</Text>
                        </Pressable>
                        <input
                           id="yearbookFileInput"
                           type="file"
                           onChange={handleYearbookImageUpload}
                           accept="image/*"
                           style={{ display: 'none' }}
                        />
                        <Pressable style={styles.sendButton} onPress={handleSend}>
                           <Text style={styles.sendButtonText}>Send</Text>
                        </Pressable>
                     </View>
                     {uploadStatus.loading && <Text style={styles.loadingText}>Uploading image...</Text>}
                     {uploadStatus.error && <Text style={styles.errorText}>{uploadStatus.error}</Text>}
                     {uploadStatus.success && <Text style={styles.successText}>{uploadStatus.success}</Text>}
                     {image && (
                        <View style={styles.previewContainer}>
                           <Image source={{ uri: image }} style={styles.previewImage} />
                        </View>
                     )}
                     {!currentUser && (
                        <View style={styles.signatureContainer}>
                           <TextInput
                              style={styles.signatureInput}
                              placeholder="First Name"
                              value={signature.firstName}
                              onChangeText={(text) => setSignature({ ...signature, firstName: text })}
                           />
                           <TextInput
                              style={styles.signatureInput}
                              placeholder="Last Name"
                              value={signature.lastName}
                              onChangeText={(text) => setSignature({ ...signature, lastName: text })}
                           />
                        </View>
                     )}
                  </View>
               </ImageBackground>
            )}

            {activeTab === "GoalTracker" && (
               <ImageBackground
                  source={{ uri: goalData?.goalPictureURL || backgroundImage }}
                  style={styles.goalTrackerBackground}
                  imageStyle={styles.goalTrackerImage}
               >
                  <View style={styles.goalTrackerContent} {...spotlightTarget(SPOTLIGHT_TARGETS.ANNOUNCEMENT_FUND_SECTION)}>
                     {showEditGoal && !isVisitorView ? (
                        <View style={styles.editGoalContainer}>
                           <GradFundGoalEditor
                              title={goalData.title}
                              description={goalData.description}
                              targetAmount={shouldHideDefaultGoalTarget ? "" : String(goalData.targetAmount || "")}
                              onChangeField={handleGoalFieldChange}
                              onSave={handleSaveGoal}
                              onCancel={() => setShowEditGoal(false)}
                              onResetTarget={handleResetTargetAmount}
                              canResetTarget={hasEstablishedGoal}
                              photoLabel={`Upload Photo ${!myTasselPlus.hasPlus ? "+" : ""}`}
                              onRequestPhoto={(openPhotoPicker) => myTasselPlus.requireFeature(MYTASSEL_PLUS_FEATURES.GOAL_IMAGE, openPhotoPicker)}
                              onPhotoSelected={handleGoalImageUpload}
                              photoPreviewUri={goalImage}
                              photoMessage={goalPhotoMessage}
                           />
                        </View>
                     ) : (
                        <View style={styles.goalDetails}>
                           {goalData.goalPictureURL && (
                              <Image source={{ uri: goalData.goalPictureURL }} style={styles.goalImage} />
                           )}

                           <View style={styles.goalTextContainer}>
                              <Text style={styles.title}>{goalData.title}</Text>
                              <Text style={styles.description}>{goalData.description}</Text>

                              {showGoalOnboarding && <GradFundGoalOnboarding />}

							{hasEstablishedGoal ? (
								/* Show contribution amounts only to page owners and graduates */
								(pageOwnerId === currentUserData?.uid) || 
								(currentUserData?.accountType === "Graduate" || currentUserData?.accountType === "G") || 
								isVisitorView ? (
									<Text style={styles.amount}>
										${goalAmountContributed} of ${goalTargetAmount}
									</Text>
								) : (
									<Text style={styles.amount}>
										Goal: ${goalTargetAmount}
									</Text>
								)
							) : (
								null
							)}
							{hasEstablishedGoal ? (
								<View style={styles.contributionBar}>
									<View style={{ ...styles.filledBar, width: `${progressPercent}%` }} />
								</View>
							) : null}
							{isCurrentPageOwner && !isVisitorView ? (
								<Pressable style={styles.button} onPress={() => setShowEditGoal(true)}>
									<Text style={styles.buttonText}>{showGoalOnboarding ? 'Set Your Goal' : 'Edit Goal'}</Text>
								</Pressable>
                              ) : (
                                 hasEstablishedGoal && hasCompletedStripeSetup ? (
                                    <Pressable
                                       style={[styles.button, isSampleEvent && { opacity: 0.5, cursor: 'not-allowed' }]}
                                       onPress={isSampleEvent ? undefined : handleContribution}
                                       disabled={isSampleEvent}
                                    >
                                       <Text style={styles.contributionButtonText}>Make a Contribution</Text>
                                       {isSampleEvent && (
                                          <Text style={{ color: 'red', fontSize: 12 }}>Disabled on sample page</Text>
                                       )}
                                    </Pressable>
                                 ) : hasEstablishedGoal ? (
                                    <View style={styles.contributionNotReadyContainer}>
                                       <Ionicons name="lock-closed" size={28} color="#4c956c" style={{ marginBottom: 6 }} />
                                       <Text style={styles.contributionNotReadyTitle}>Contributions coming soon</Text>
                                       <Text style={styles.contributionNotReadyText}>This graduate hasn't finished setting up contributions yet. Check back later!</Text>
                                    </View>
                                 ) : (
                                    <View style={styles.noGoalContainer}>
                                       <Text style={styles.noGoalText}>This graduate hasn't set a goal yet. Please check back later.</Text>
                                    </View>
                                 )
                              )}
                              {isCurrentPageOwner && !hasCompletedStripeSetup && !isVisitorView &&
                                 <Pressable style={styles.button} onPress={() => setShowConnectedAccountModal(true)}>
                                    <Text style={styles.buttonText}>{pageOwner?.stripeAccountId ? 'Finish Stripe Setup' : 'Activate Your Grad Fund'}</Text>
                                 </Pressable>
                              }
                           </View>
                        </View>
                     )}
                  </View>
               </ImageBackground>
            )}

            {activeTab === "Registry" && (
               <ImageBackground
                  source={{ uri: backgroundImage }}
                  style={styles.yearbookBackground}
                  imageStyle={styles.yearbookImage}
               >
                  <View style={styles.registryContainer}>
                     {pageOwner.pages.registry ? (
                        <Text style={styles.registryText}>Redirecting to the registry...</Text>
                     ) : (
                        <View style={styles.noRegistryContainer}>
                           <Text style={styles.noRegistryText}>
                              {isVisitorView ? (
                                 "This graduate hasn't created a registry yet, but you can click here for gift ideas and to make a purchase for them."
                              ) : (
                                 pageOwnerId === currentUserData?.uid
                                    ? "You haven't created your registry yet. Start creating it here."
                                    : "This graduate hasn't created a registry yet, but you can click here for gift ideas and to make a purchase for them."
                              )}
                           </Text>
                           <Pressable
                              style={styles.catalogueButton}
                              onPress={() => {
                                 if (!isVisitorView && pageOwnerId === currentUserData?.uid) {
                                    navigation.navigate("Hub", { showRegistryModal: true });
                                 } else {
                                    setShowCatalogueModal(true);
                                 }
                              }}
                           >
                              <Text style={styles.catalogueButtonText}>
                                 {!isVisitorView && pageOwnerId === currentUserData?.uid ? "Create Registry" : "Go to Catalogue"}
                              </Text>
                           </Pressable>
                        </View>
                     )}
                  </View>
               </ImageBackground>
            )}

            {activeTab === "Share" && (
               <ImageBackground
                  source={{ uri: backgroundImage }}
                  style={styles.yearbookBackground}
                  imageStyle={styles.yearbookImage}
               >
                  <View {...spotlightTarget(SPOTLIGHT_TARGETS.ANNOUNCEMENT_SHARE_SECTION)} style={[
                     styles.shareFormContainer,
                     {
                        minHeight: isMobile ? (activeShareTab === "qr" ? 300 : 180) 
                        : "auto",
                     }
                  ]}>
                     <Text style={styles.shareFormTitle}>Share Announcement Page</Text>
                     {isSharing && <Text style={styles.successMessage}>Sending invitations...</Text>}
                     {isShared && !isError && <Text style={styles.successMessage}>Shared successfully!</Text>}
                     {isError && <Text style={styles.errorMessage}>{error}</Text>}
                     <View style={styles.recipientTypeContainer}>
                        <Pressable 
                           onPress={() => {
                              setRecipientType("email");
                              setActiveShareTab("email");
                              setError("");
                              setIsError(false);
                           }}
                           style={{
                              ...styles.typeButton,
                              ...(activeShareTab === "email" ? styles.activeTypeButton : {})
                           }}
                        >
                           <Text style={activeShareTab === "email" ? styles.activeTypeButtonText : styles.typeButtonText}>Email</Text>
                        </Pressable>
                        <Pressable 
                           onPress={() => {
                              setRecipientType("phone");
                              setActiveShareTab("phone");
                              setError("");
                              setIsError(false);
                           }}
                           style={{
                              ...styles.typeButton,
                              ...(activeShareTab === "phone" ? styles.activeTypeButton : {})
                           }}
                        >
                           <Text style={activeShareTab === "phone" ? styles.activeTypeButtonText : styles.typeButtonText}>SMS</Text>
                        </Pressable>
                        <Pressable
                           onPress={() => {
                              setActiveShareTab("qr");
                              setQrCodeValue(generateQrCodeUrl());
                           }}
                           style={{
                              ...styles.typeButton,
                              ...(activeShareTab === "qr" ? styles.activeTypeButton : {})
                           }}
                        >
                           <Text style={activeShareTab === "qr" ? styles.activeTypeButtonText : styles.typeButtonText}>QR</Text>
                        </Pressable>
                     </View>
                     {activeShareTab === "email" && (
                        <>
                           <TextInput
                              style={[styles.input, isError && styles.inputError]}
                              placeholder="Enter recipient emails, separated by commas"
                              value={recipientEmails}
                              onChangeText={(text) => {
                                 setError("");
                                 setIsError(false);
                                 setRecipientEmails(text);
                              }}
                           />
                           <Pressable 
                              style={styles.button} 
                              onPress={handleShare}
                              disabled={isSharing || !recipientEmails.trim()}
                           >
                              <Text style={styles.buttonText}>Share via Email</Text>
                           </Pressable>
                        </>
                     )}
                     {activeShareTab === "phone" && (
                        <>
                           <TextInput
                              style={[styles.input, isError && styles.inputError]}
                              placeholder="Enter phone numbers, separated by commas"
                              value={phoneNumbers}
                              onChangeText={(text) => {
                                 setError("");
                                 setIsError(false);
                                 setPhoneNumbers(text);
                              }}
                           />
                           <Pressable 
                              style={styles.button} 
                              onPress={() => {
                                 const phoneList = phoneNumbers.split(',').map(phone => phone.trim());
                                 shareViaSMS(phoneList);
                              }}
                              disabled={isSharing || !phoneNumbers.trim()}
                           >
                              <Text style={styles.buttonText}>Share via SMS</Text>
                           </Pressable>
                        </>
                     )}
                     {activeShareTab === "qr" && (
                        <View style={{ alignItems: 'center', width: '100%' }}>
                           <QRCodeShare url={qrCodeValue} />
                        </View>
                     )}
                  </View>
               </ImageBackground>
            )}
         </View>

         {/* Modern Stepwise Contribution Flow (same as Registry) */}
         {pageOwner && stripePromise && (
            <Elements stripe={stripePromise}>
               <ContributionFlow
                  isVisible={showContributionFlow}
                  onClose={() => setShowContributionFlow(false)}
                  pageOwner={pageOwner}
               />
            </Elements>
         )}

         {/* Legacy eCard Selection Modal */}
         <ECardSelectionModal
            isVisible={showECardModal}
            onSelect={handleECardSelection}
            onClose={() => setShowECardModal(false)}
         />

         {/* Legacy Checkout Modal */}
         <Elements stripe={stripePromise}>
            <Checkout
               isVisible={showCheckoutModal}
               onClose={() => setShowCheckoutModal(false)}
               onContribute={submitContribution}
               selectedECard={selectedECard}
               pageOwner={pageOwner}
            />
         </Elements>

         {/* Connected Account Modal */}
         {showConnectedAccountModal &&
            <>
               <ConnectedAccount pageOwner={pageOwner} />
               <ConnectedAccountModal
                  visible={showConnectedAccountModal}
                  onClose={() => setShowConnectedAccountModal(false)}
                  pageOwner={pageOwner}
               />
            </>
         }

         {/* Catalogue Modal */}
         {showCatalogueModal && (
            <View style={styles.modalOverlay}>
               <View style={[styles.modalContent, styles.catalogueModalContent]}>
                  <Pressable style={styles.closeButton} onPress={() => setShowCatalogueModal(false)}>
                     <Text style={styles.closeButtonText}>X</Text>
                  </Pressable>
                  <Catalogue
                     isVisible={showCatalogueModal}
                     onClose={() => setShowCatalogueModal(false)}
                  />
               </View>
            </View>
         )}

         <SharedModal 
            isVisible={showEmailWarning}
            onClose={() => setShowEmailWarning(false)}
            title="Heads Up! Check That Junk Folder!"
            message="Sometimes our emails like to play hide and seek and might end up in a spam or junk folder! Let your friends and family know to give that folder a quick peek. We promise we're not spam - just here to celebrate your big moment!"
            confirmText="Got it, Send Email"
            onConfirm={() => {
               setShowEmailWarning(false);
               shareAnnouncementPage();
            }}
         />
         
         {/* Edit Message Modal */}
         <Modal
            visible={showEditModal}
            transparent={true}
            animationType="fade"
            onRequestClose={() => setShowEditModal(false)}
         >
            <View style={styles.modalOverlay}>
               <View style={styles.modalContent}>
                  <View style={styles.modalHeader}>
                     <Text style={styles.modalTitle}>Edit Message</Text>
                     <Pressable 
                        style={styles.modalCloseButton}
                        onPress={() => setShowEditModal(false)}
                     >
                        <Text style={styles.modalCloseText}>✕</Text>
                     </Pressable>
                  </View>
                  
                  <TextInput
                     style={styles.editInput}
                     placeholder="Edit your message..."
                     value={editText}
                     onChangeText={setEditText}
                     multiline
                  />
                  
                  {editImage && (
                     <View style={styles.editImageContainer}>
                        <Image source={{ uri: editImage }} style={styles.editImagePreview} />
                        <Pressable 
                           style={styles.removeImageButton}
                           onPress={() => setEditImage(null)}
                        >
                           <Text style={styles.removeImageText}>Remove Image</Text>
                        </Pressable>
                     </View>
                  )}
                  
                  <View style={styles.modalButtonContainer}>
                     <Pressable style={styles.editUploadButton} onPress={() => document.getElementById('editYearbookFileInput').click()}>
                        <Text style={styles.editUploadButtonText}>Change Photo</Text>
                     </Pressable>
                     <input
                        id="editYearbookFileInput"
                        type="file"
                        onChange={handleEditImageUpload}
                        accept="image/*"
                        style={{ display: 'none' }}
                     />
                     
                     <View style={styles.modalActionButtons}>
                        <Pressable 
                           style={styles.cancelButton}
                           onPress={() => setShowEditModal(false)}
                        >
                           <Text style={styles.cancelButtonText}>Cancel</Text>
                        </Pressable>
                        <Pressable 
                           style={styles.updateButton}
                           onPress={handleUpdateMessage}
                        >
                           <Text style={styles.updateButtonText}>Update</Text>
                        </Pressable>
                     </View>
                  </View>
               </View>
            </View>
         </Modal>
            {/* Reply Modal */}
            <Modal visible={showReplyModal} transparent animationType="fade" onRequestClose={() => setShowReplyModal(false)}>
               <View style={styles.modalOverlay}>
                  <View style={styles.modalContent}>
                     <View style={styles.modalHeader}>
                        <Text style={styles.modalTitle}>Reply to Message</Text>
                        <Pressable style={styles.modalCloseButton} onPress={() => setShowReplyModal(false)}><Text style={styles.modalCloseText}>✕</Text></Pressable>
                     </View>
                     {messageToReply && (<View style={styles.replyContext}><Text style={styles.replyContextText}>Replying to {messageToReply.senderFirstName} {messageToReply.senderLastName}: {messageToReply.text || messageToReply.message}</Text></View>)}
                     <TextInput style={styles.editInput} placeholder="Write your reply..." value={replyText} onChangeText={setReplyText} multiline />
                     <View style={styles.modalActionButtons}>
                        <Pressable style={styles.cancelButton} onPress={() => setShowReplyModal(false)}><Text style={styles.cancelButtonText}>Cancel</Text></Pressable>
                        <Pressable style={styles.updateButton} onPress={handleSendReply}><Text style={styles.updateButtonText}>Send Reply</Text></Pressable>
                     </View>
                  </View>
               </View>
            </Modal>
            {/* Actions Menu Modal (ellipsis) */}
            <Modal visible={showActionsFor !== null && actionsMenuData !== null} transparent animationType="none" onRequestClose={() => { setShowActionsFor(null); setActionsMenuData(null); setActionsMenuPosition(null); }}>
               <Pressable style={styles.actionsModalOverlay} onPress={() => { setShowActionsFor(null); setActionsMenuData(null); setActionsMenuPosition(null); }}>
                  <View style={[styles.actionsMenu, actionsMenuPosition && { position: 'absolute', left: actionsMenuPosition.x + (actionsMenuPosition.width || 0) + 8, top: actionsMenuPosition.y }]} onStartShouldSetResponder={() => true}>
                     {actionsMenuData && (
                        <>
                           {currentUserData?.uid && (
                              <Pressable style={styles.menuButton} onPress={() => { handleReplyClick(actionsMenuData); setShowActionsFor(null); setActionsMenuData(null); setActionsMenuPosition(null); }}>
                                 <Ionicons name="return-up-forward" size={14} color="#666" />
                                 <Text style={styles.menuButtonText}>Reply</Text>
                              </Pressable>
                           )}
                           {(currentUserData?.uid === actionsMenuData?.senderUID || currentUserData?.uid === actionsMenuData?.createdBy || (!currentUserData?.uid && actionsMenuData?.sessionId === sessionId && actionsMenuData?.senderUID === 'anonymous')) && (
                              <Pressable style={styles.menuButton} onPress={() => { handleEditMessage(actionsMenuData); setShowActionsFor(null); setActionsMenuData(null); setActionsMenuPosition(null); }}>
                                 <Ionicons name="create-outline" size={14} color="#666" />
                                 <Text style={styles.menuButtonText}>Edit</Text>
                              </Pressable>
                           )}
                           {isPageOwner() && actionsMenuData?.senderUID !== currentUserData?.uid ? (
                              <>
                                 <Pressable style={styles.menuButton} onPress={() => { handleHideMessage(actionsMenuData); setShowActionsFor(null); setActionsMenuData(null); setActionsMenuPosition(null); }}>
                                    <Ionicons name={actionsMenuData?.hidden ? 'eye' : 'eye-off'} size={14} color="#666" />
                                    <Text style={styles.menuButtonText}>{actionsMenuData?.hidden ? 'Unhide' : 'Hide'}</Text>
                                 </Pressable>
                                 <Pressable style={styles.menuButton} onPress={() => { handleDeleteMessage(actionsMenuData); setShowActionsFor(null); setActionsMenuData(null); setActionsMenuPosition(null); }}>
                                    <Ionicons name="trash" size={14} color="#666" />
                                    <Text style={styles.menuButtonText}>Delete</Text>
                                 </Pressable>
                              </>
                           ) : (
                              <>
                                 {(currentUserData?.uid === actionsMenuData?.senderUID || currentUserData?.uid === actionsMenuData?.createdBy || (!currentUserData?.uid && actionsMenuData?.sessionId === sessionId && actionsMenuData?.senderUID === 'anonymous')) && (
                                    <Pressable style={styles.menuButton} onPress={() => { handleDeleteMessage(actionsMenuData); setShowActionsFor(null); setActionsMenuData(null); setActionsMenuPosition(null); }}>
                                       <Ionicons name="trash" size={14} color="#666" />
                                       <Text style={styles.menuButtonText}>Delete</Text>
                                    </Pressable>
                                 )}
                              </>
                           )}
                        </>
                     )}
                  </View>
               </Pressable>
            </Modal>
         
         {/* Delete Confirmation Modal */}
         <Modal
            visible={showDeleteModal}
            transparent={true}
            animationType="fade"
            onRequestClose={() => setShowDeleteModal(false)}
         >
            <View style={styles.modalOverlay}>
               <View style={styles.modalContent}>
                  <View style={styles.modalHeader}>
                     <Text style={styles.modalTitle}>Delete Message</Text>
                     <Pressable 
                        style={styles.modalCloseButton}
                        onPress={() => setShowDeleteModal(false)}
                     >
                        <Text style={styles.modalCloseText}>✕</Text>
                     </Pressable>
                  </View>
                  
                  <Text style={styles.deleteConfirmText}>
                     Are you sure you want to permanently delete this message? This action cannot be undone.
                  </Text>
                  
                  <View style={styles.modalActionButtons}>
                     <Pressable 
                        style={styles.cancelButton}
                        onPress={() => setShowDeleteModal(false)}
                     >
                        <Text style={styles.cancelButtonText}>Cancel</Text>
                     </Pressable>
                     <Pressable 
                        style={styles.deleteConfirmButton}
                        onPress={confirmDeleteMessage}
                     >
                        <Text style={styles.deleteConfirmButtonText}>Delete</Text>
                     </Pressable>
                  </View>
               </View>
            </View>
         </Modal>
         {myTasselPlus.upsellModal}
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      minHeight: isMobile ? 200 : 0,
      height: "auto",
      width: '100%',
      maxWidth: '100%',
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: 0,
      backgroundColor: "transparent",
      borderRadius: isMobile ? 15 : isTablet ? 20 : isSmallDesktop ? 25 : 30,
      shadowColor: "rgba(0, 0, 0, 0)",
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5,
      marginVertical: isMobile ? 5 : 10,
      marginTop: isMobile ? 30 : 50,
      zIndex: 2,
      alignSelf: 'stretch',
      overflow: 'visible',
      justifyContent: 'flex-start',
      boxSizing: 'border-box',
   },
   innerContainer: {
      minHeight: isMobile ? 200 : 0,
      height: "auto",
      width: '100%',
      maxWidth: '100%',
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      borderRadius: isMobile ? 15 : isTablet ? 20 : isSmallDesktop ? 25 : 30,
      shadowColor: "rgba(0, 0, 0, 0.5)",
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5,
      marginVertical: isMobile ? 5 : 10,
      marginTop: isMobile ? 30 : 50,
      zIndex: 2,
      backgroundColor: "rgba(254, 253, 226, 1)",
      alignSelf: 'stretch',
   },
   tabContainer: {
      flexDirection: "row",
      justifyContent: "center",
      position: "absolute",
      top: isMobile ? -65 : -85, 
      zIndex: 1,
      width: "100%",
   },
   tabButton: {
      padding: isMobile ? 7.5 : 10,
      borderRadius: 5,
      marginHorizontal: isMobile ? -5 : 5, 
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      borderRadius: 15,
      borderBottomWidth: 0,
      zIndex: 1,
      backgroundColor: "rgba(254, 253, 226, .90)",
   },
   activeTabButton: {
      backgroundColor: "#4c956c",
      borderBottomWidth: 0,
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      zIndex: 1,
   },
   tabButtonText: {
      fontWeight: "bold",
      color: "#4c956c",
      fontSize: isMobile ? 10 : 16,
   },
   activeTabButtonText: {
      fontWeight: "bold",
      color: "#fefde2",
      fontSize: isMobile ? 10 : 16,
   },
   yearbookBackground: {
      width: '100%',
      minHeight: isMobile || isTablet || isSmallDesktop ? 300 :  400,
      height: 'auto',
      padding: 20,
      borderRadius: isMobile ? 15 : isTablet ? 20 : isSmallDesktop ? 25 : 30,
      borderTopWidth: 0,
      overflow: 'hidden',
      zIndex: 0,
   },
   yearbookImage: {
      flex: 1,
      resizeMode: "cover",
      borderRadius: isMobile ? 15 : isTablet ? 20 : isSmallDesktop ? 25 : 30,
   },
   yearbookContainer: {
      // flex: 1, // REMOVE THIS
      padding: isMobile ? 10 : 20,
      backgroundColor: "rgba(255, 255, 255, 0.8)",
      borderRadius: isMobile ? 15 : isTablet ? 20 : isSmallDesktop ? 25 : 30,
      overflow: "visible",
      justifyContent: "space-between",
      minHeight: 400,
      height: 'auto',
   },
   messagesContainer: {
      flex: 1,
      maxHeight: isMobile ? 400 : isTablet ? 500 : 600,
      marginBottom: 10,
      borderRadius: 15,
   },
   message: {
      marginBottom: 10,
      padding: isMobile ? 7.5 : 10,
      borderRadius: 10,
      flexDirection: "row",
      alignItems: "center",
   },
   currentUserMessage: {
      backgroundColor: "#4c956c",
      alignSelf: "flex-end",
   },
   otherUserMessage: {
      backgroundColor: "rgba(254, 253, 226, 1)",
      alignSelf: "flex-start",
   },
   messageImage: {
      width: "100%",
      height: isMobile ? 50 : 200,
      borderRadius: 10,
      marginBottom: 10,
   },
   // Reply reference styles (match Registry Yearbook)
   replyReference: { padding: 8, borderRadius: 8, marginBottom: 5, backgroundColor: '#e0e0e0', maxWidth: '70%' },
   replyReferenceLeft: { marginLeft: 35, alignSelf: 'flex-start' },
   replyReferenceRight: { marginRight: 35, alignSelf: 'flex-end' },
   replyReferenceText: { fontSize: 12, fontWeight: 'bold', color: '#555' },
   replyOriginalText: { fontSize: 12, color: '#777', marginTop: 2 },
   replyMessage: { borderLeftWidth: 3, borderLeftColor: '#4c956c', paddingLeft: 8 },
   profileImage: {
      width: isMobile ? 20 : 25,
      height: isMobile ? 20 : 25,
      borderRadius: 25,
      marginRight: 10,
   },
   messageContent: {
      flex: 1,
   },
   messageSender: {
      fontWeight: "bold",
      marginBottom: 5,
      color: "#000",
      fontSize: isMobile ? 10 : 16,
   },
   messageText: {
      fontSize: isMobile ? 10 : 16,
      color: "#000",
   },
   messageTimestamp: {
      color: "#666",
      marginTop: 2,
      fontSize: isMobile ? 8 : 12,
   },
   yearbookInputContainer: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: "rgba(254, 253, 226, 1)",
      borderRadius: 10,
      padding: isMobile ? 7.5 : 10,
      marginBottom: isMobile ? 5 : 10, // Ensure spacing at the bottom
      width: isMobile ? "100%" : "100%",
   },
   yearbookInput: {
      flex: 1,
      marginRight: 10,
      padding: 10,
      borderRadius: 10,
      borderColor: "#ccc",
      backgroundColor: "#fff",
      borderWidth: 1,
      width: "70%",
      height: 40,
      marginRight: 10,
      fontSize: isMobile ? 10 : 16,
   },
   yearbookInputPlaceholder: {
      color: "#ccc",
      fontSize: isMobile ? 10 : 16,
   },
   uploadButton: {
      backgroundColor: "#4c956c",
      padding: isMobile ? 7.5 : 10,
      borderRadius: 10,
      marginRight: isMobile ? 5 : 10,
      justifyContent: "center",
      alignItems: "center",
   },
   uploadButtonGoal: {
      backgroundColor: "#4c956c",
      padding: 10,
      borderRadius: 10,
      marginRight: 10,
      marginBottom: 10,
      justifyContent: "center",
      alignItems: "center",
   },
   uploadButtonText: {
      color: "#fff",
      fontWeight: "bold",
      fontSize: isMobile ? 10 : 16,
   },
   sendButton: {
      backgroundColor: "#4c956c",
      padding: isMobile ? 7.5 : 10,
      borderRadius: 10,
      width: isMobile ? "20%" : "10%",
      justifyContent: "center",
      alignItems: "center",
   },
   sendButtonText: {
      color: "#fff",
      fontWeight: "bold",
      fontSize: isMobile ? 10 : 16,
   },
   signatureContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 10,
      width: "100%",
      gap: isMobile ? 6 : 10,
   },
   signatureInput: {
      flex: 1,
      minWidth: 0,
      borderWidth: 1,
      borderColor: "#ddd",
      padding: isMobile ? 7.5 : 10,
      fontSize: isMobile ? 12 : 16,
      borderRadius: 10,
      backgroundColor: "#fff",
   },
   goalTrackerBackground: {
      flex: 1,
      width: "100%",
      // padding: 20,
      borderRadius: 15,
      borderTopWidth: 0,
      zIndex: 0,
      overflow: "visible",
   },
   goalTrackerImage: {
      borderRadius: 15,
      zIndex: 3,
   },
   goalTrackerContent: {
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      borderRadius: 15,
      padding: isMobile ? 10 : 20,
      height: "auto",
      width: "100%",
      zIndex: 3,
      minHeight: isMobile ? 300 : 400,
      overflow: "hidden",
   },
   goalDetails: {
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      width: isMobile ? "100%" : "80%",
   },
   goalTextContainer: {
      flex: 1,
      marginLeft: isMobile ? 0 : 20,
      marginTop: isMobile ? 10 : 0,
      width: isMobile ? "100%" : "80%",
   },
   goalImage: {
      width: isMobile ? 200 : 400,
      height: isMobile ? 200 : 400,
      borderRadius: 10,
   },
   title: {
      fontSize: 24,
      fontWeight: "bold",
      marginBottom: 10,
      color: "#fff",
      textShadowColor: "rgba(0, 0, 0, 0.5)",
      textShadowRadius: 3.84,
   },
   description: {
      fontSize: 16,
      marginBottom: 10,
      color: "#fff",
      textShadowColor: "rgba(0, 0, 0, 0.5)",
      textShadowRadius: 3.84,
   },
   amount: {
      fontSize: 18,
      marginBottom: 10,
      color: "#fff",
      textShadowColor: "rgba(0, 0, 0, 0.5)",
      textShadowRadius: 3.84,
   },
   contributionBar: {
      height: 20,
      backgroundColor: "#ddd",
      borderRadius: 10,
      overflow: "hidden",
      marginBottom: 10,
      shadowColor: "rgba(0, 0, 0, 0.5)",
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5,
      width: "100%",
   },
   filledBar: {
      height: "100%",
      backgroundColor: "#4c956c",
      shadowColor: "rgba(0, 0, 0, 0.5)",
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5,
      width: "100%",
   },
   messageCard: {
      flexDirection: "row",
      backgroundColor: "#4c956c",
      padding: 10,
      borderRadius: 5,
      marginBottom: 10,
   },
   pageOwnerMessage: {
      alignSelf: "flex-end",
   },
   userMessage: {
      alignSelf: "flex-start",
   },
   profilePhoto: {
      width: 40,
      height: 40,
      borderRadius: 20,
      marginRight: 10,
   },
   messageContent: {
      flex: 1,
   },
   messageSender: {
      fontWeight: "bold",
      color: "#fff",
   },
   messageText: {
      marginTop: 5,
      color: "#fff",
   },
   messageImage: {
      width: 100,
      height: 100,
      marginTop: 5,
      borderRadius: 5,
   },
   messageTimestamp: {
      marginTop: 5,
      fontSize: 10,
      color: "#fff",
   },
   modalContent: {
      backgroundColor: "#fff",
      padding: 20,
      borderRadius: 20,
      shadowColor: "rgba(0, 0, 0, 0.5)",
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5,
   },
   text: {
      fontSize: 18,
      marginBottom: 10,
   },
   buttonRed: {
      backgroundColor: "#cc0000",
      padding: 10,
      borderRadius: 5,
      alignItems: "center",
      marginTop: 10,
   },
   modalContainer: {
      position: "absolute",
      top: 20,
      left: 20,
      right: 20,
      bottom: 20,
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      borderRadius: 15,
      padding: 20,
      zIndex: 1000,
   },
   closeButton: {
      position: "absolute",
      top: 20,
      left: 20,
      width: 30,
      height: 30,
      borderRadius: 15,
      backgroundColor: "red",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 3,
   },
   closeButtonText: {
      color: "#fff",
      fontSize: 20,
   },
   otherUserText: {
      color: "#333",
   },
   editGoalContainer: {
      flex: 1,
      width: "100%",
      alignItems: "center",
   },
   contributionContainer: {
      flex: 1,
      padding: 20,
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      borderRadius: 15,
   },
   previewContainer: {
      marginTop: 10,
      alignItems: 'center',
      paddingBottom: 10
   },
   previewImage: {
      width: 100,
      height: 100,
      borderRadius: 10,
   },
   modalContainer: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
   },
   modalContent: {
      backgroundColor: '#fff',
      padding: 30,
      borderRadius: 15,
      width: '95%',
      maxWidth: isMobile ? '95%' : '90%',
      maxHeight: '90vh',
      alignItems: 'center',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      zIndex: 100000,
      position: 'fixed',
      left: '50%',
      top: '50%',
      transform: [{ translateX: '-50%' }, { translateY: '-50%' }],
      overflow: 'auto'
   },
   modalTitle: {
      fontSize: 18,
      fontWeight: "bold",
      marginBottom: 10,
   },
   input: {
      width: isMobile || isTablet ? '100%' : 500,
      maxWidth: 400,
      alignSelf: isMobile || isTablet ? undefined : 'center',
      padding: 10,
      borderColor: "#ccc",
      borderWidth: 1,
      borderRadius: 5,
      marginBottom: 10,
      fontSize: isMobile ? 10 : 16,
   },
   button: {
      backgroundColor: "#4c956c",
      padding: isMobile ? 7.5 : 10,
      borderRadius: 5,
      alignItems: "center",
      marginBottom: 10,
   },
   buttonText: {
      color: "#fff",
      fontWeight: "bold",
      fontSize: isMobile ? 10 : 16,
   },
   contributionButtonText: {
      color: "#fff",
      fontWeight: "bold",
      fontSize: isMobile ? 12 : 16,
   },
   shareFormContainer: {
      padding: 40,
      backgroundColor: "#fefde2",
      borderRadius: 10,
      alignItems: "center",
      marginTop: isMobile ? 20 : 50,
      width: "100%",
      minHeight: "auto",
      overflow: "visible",
   },
   shareFormTitle: {
      fontSize: isMobile ? 16 : 22,
      fontWeight: "bold",
      marginBottom: isMobile ? 5 : 10,
   },
   noGoalContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: isMobile ? 300 : 400,
      flex: 1,
   },
   contributionNotReadyContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: isMobile ? 300 : 400,
      flex: 1,
      paddingHorizontal: 20,
   },
   contributionNotReadyTitle: {
      fontSize: isMobile ? 16 : 20,
      fontWeight: 'bold',
      color: '#fefde2',
      textAlign: 'center',
      marginBottom: 6,
      textShadowColor: 'rgba(0,0,0,0.25)',
      textShadowOffset: { width: 0, height: 1 },
      textShadowRadius: 2,
   },
   contributionNotReadyText: {
      fontSize: isMobile ? 13 : 15,
      color: '#fefde2',
      textAlign: 'center',
      textShadowColor: 'rgba(0,0,0,0.25)',
      textShadowOffset: { width: 0, height: 1 },
      textShadowRadius: 2,
   },
   noGoalText: {
      fontSize: isMobile ? 16 : 20,
      textAlign: "center",
      marginTop: isMobile ? 10 : 20,
      color: "#fefde2",
      fontWeight: "bold",
      position: "absolute",
      justifyContent: "center",
      alignItems: "center",
      textShadowColor: "rgba(0, 0, 0, 0.25)",
      textShadowRadius: 3.84,
      textShadowOffset: { width: 0, height: 4 },
      textShadowRadius: 3.84,
      textAlign: "center",
   },
   loadingText: {
      color: "blue",
      fontSize: isMobile ? 10 : 16,
      marginTop: 10,
   },
   errorText: {
      color: "red",
      fontSize: isMobile ? 10 : 16,
      marginTop: 10,
   },
   successText: {
      color: "green",
      fontSize: isMobile ? 10 : 16,
      marginTop: 10,
   },
   registryContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      padding: isMobile ? 15 : 18,
      minHeight: isMobile ? 300 : "auto",
   },
   noRegistryContainer: {
      justifyContent: 'center',
      alignItems: 'center',
   },
   noRegistryText: {
      fontSize: 20,
      textAlign: 'center',
      marginBottom: 20,
      color: "#fefde2",
      fontWeight: "bold",
   },
   catalogueButton: {
      backgroundColor: '#4c956c',
      padding: 10,
      borderRadius: 5,
      // backgroundColor: "red"
   },
   catalogueButtonText: {
      color: '#fff',
      fontWeight: 'bold',
   },
   blurBackground: {
      filter: 'blur(5px)',
      zIndex: 1,
      width: "100%",
      height: "100%",
   },
   modalOverlay: {
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(10px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 99999,
      overflow: 'hidden',
   },
   successMessage: {
      color: "green",
      fontSize: isMobile ? 12 : 16,
      marginBottom: 10,
   },
   errorMessage: {
      color: "red",
      fontSize: isMobile ? 12 : 16,
      marginBottom: 10,
   },
   recipientTypeContainer: {
      flexDirection: "row",
      justifyContent: "center",
      marginBottom: 10,
   },
   typeButton: {
      padding: isMobile ? 7.5 : 10,
      borderRadius: 5,
      marginHorizontal: 5,
   },
   activeTypeButton: {
      backgroundColor: "#4c956c",
      borderBottomWidth: 0,
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      zIndex: 1,
   },
   typeButtonText: {
      fontWeight: "bold",
      color: "#ccc",
      fontSize: isMobile ? 10 : 16,
   },
   activeTypeButtonText: {
      fontWeight: "bold",
      color: "#fff",
      fontSize: isMobile ? 10 : 16,
   },
   inputError: {
      borderColor: "red",
   },
   comingSoonContainer: {
      alignItems: 'center',
      padding: 20,
      backgroundColor: '#fefde2',
      borderRadius: 10,
      margin: 20,
   },
   comingSoonText: {
      fontSize: 24,
      color: '#4c956c',
      fontWeight: 'bold',
      marginBottom: 10,
      textAlign: 'center',
   },
   comingSoonSubtext: {
      fontSize: 16,
      color: '#666',
      textAlign: 'center',
   },
   modalTitle: {
      color: '#4c956c',
      marginBottom: 20,
      fontSize: 24,
      fontWeight: 'bold',
      textAlign: 'center',
      width: '100%',
   },
   modalText: {
      color: '#333',
      marginBottom: 25,
      lineHeight: 24,
      textAlign: 'center',
      fontSize: 16,
      width: '100%',
   },
   modalButtons: {
      flexDirection: 'row',
      justifyContent: 'center',
      gap: 15,
      width: '100%',
      marginTop: 10,
   },
   modalButton: {
      padding: 10,
      paddingHorizontal: 20,
      borderRadius: 5,
      backgroundColor: '#4c956c',
      minWidth: 120,
      alignItems: 'center',
   },
   modalButtonText: {
      color: 'white',
      fontSize: 16,
      fontWeight: 'bold',
   },
   catalogueModalContent: {
      padding: 15,
      width: '95vw',
      maxWidth: '95vw',
      maxHeight: '90vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
   },
   catalogueScrollView: {
      flex: 1,
      width: '100%',
      marginTop: 40
   },
   tabWithDot: {
      flexDirection: 'column',
      alignItems: 'center',
      marginHorizontal: 8,
      position: 'relative',
   },
   tabDotWrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      minHeight: 56, // tab height + dot height + margin
   },
   tutorialDotAbsolute: {
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: [{ translateX: -8 }],
      zIndex: 10,
   },
   // Message editing styles
   messageHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 5,
   },
   messageActions: {
      flexDirection: 'row',
      alignItems: 'center',
   },
   actionsMenu: { position: 'absolute', flexDirection: 'column', padding: 8, backgroundColor: '#fff', borderRadius: 8, borderWidth: 1, borderColor: '#ddd', shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 5, minWidth: 100, zIndex: 10000 },
   actionsModalOverlay: { flex: 1, backgroundColor: 'transparent' },
   menuButton: { flexDirection: 'row', alignItems: 'center', paddingHorizontal: 8, paddingVertical: 4, margin: 2, backgroundColor: '#fff', borderRadius: 6, borderWidth: 1, borderColor: '#eee', cursor: 'pointer' },
   menuButtonText: { fontSize: 12, color: '#333', marginLeft: 4 },
   editButton: {
      width: 24,
      height: 24,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 6,
   },
   editButtonText: {
      color: '#4a90e2',
      fontSize: 16,
      fontWeight: 'normal',
   },
   deleteButton: {
      width: 24,
      height: 24,
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: 6,
   },
   deleteButtonText: {
      color: '#fff',
      fontSize: 14,
      fontWeight: 'bold',
   },
   timestampContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 5,
   },
   editedTimestamp: {
      fontSize: 7,
      fontStyle: 'italic',
      opacity: 0.7,
   },
   // Modal styles
   modalOverlay: {
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 20,
      paddingBottom: 20,
      paddingLeft: 20,
      paddingRight: 20,
   },
   modalContent: {
      backgroundColor: '#fff',
      borderRadius: 15,
      paddingTop: 20,
      paddingBottom: 20,
      paddingLeft: 20,
      paddingRight: 20,
      width: isMobile ? '90%' : isTablet ? '70%' : '50%',
      maxWidth: 500,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 5,
   },
   modalHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 20,
   },
   modalTitle: {
      fontSize: 18,
      fontWeight: 'bold',
      color: '#333',
   },
   modalCloseButton: {
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 5,
      paddingRight: 5,
   },
   modalCloseText: {
      fontSize: 18,
      color: '#666',
   },
   editInput: {
      borderWidth: 1,
      borderColor: '#ddd',
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 12,
      paddingRight: 12,
      fontSize: 16,
      borderRadius: 8,
      marginBottom: 15,
      minHeight: 80,
      verticalAlign: 'top',
      backgroundColor: '#f9f9f9',
   },
   editImageContainer: {
      marginBottom: 15,
      alignItems: 'center',
   },
   editImagePreview: {
      width: 120,
      height: 120,
      borderRadius: 8,
      marginBottom: 10,
   },
   removeImageButton: {
      backgroundColor: '#dc3545',
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: 12,
      paddingRight: 12,
      borderRadius: 6,
   },
   removeImageText: {
      color: '#fff',
      fontSize: 12,
   },
   modalButtonContainer: {
      gap: 15,
   },
   editUploadButton: {
      backgroundColor: '#6c757d',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 15,
      paddingRight: 15,
   },
   editUploadButtonText: {
      color: '#fff',
      fontSize: 14,
      fontWeight: '500',
   },
   modalActionButtons: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 10,
   },
   cancelButton: {
      flex: 1,
      backgroundColor: '#6c757d',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
      paddingTop: 12,
      paddingBottom: 12,
   },
   cancelButtonText: {
      color: '#fff',
      fontSize: 16,
      fontWeight: '500',
   },
   updateButton: {
      flex: 1,
      backgroundColor: '#4c956c',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
      paddingTop: 12,
      paddingBottom: 12,
   },
   updateButtonText: {
      color: '#fff',
      fontSize: 16,
      fontWeight: '500',
   },
   deleteConfirmText: {
      fontSize: 14,
      color: '#333',
      textAlign: 'center',
      marginBottom: 20,
      lineHeight: 20,
   },
   deleteConfirmButton: {
      flex: 1,
      backgroundColor: '#dc3545',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
      paddingTop: 12,
      paddingBottom: 12,
   },
   deleteConfirmButtonText: {
      color: '#fff',
      fontSize: 16,
      fontWeight: '500',
   },
   hideButton: {
      width: 24,
      height: 24,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 6,
   },
   hideButtonText: {
      color: '#ff9800',
      fontSize: 16,
      fontWeight: 'normal',
   },
   unhideButton: {
      width: 24,
      height: 24,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 6,
   },
   unhideButtonText: {
      color: '#4caf50',
      fontSize: 16,
      fontWeight: 'normal',
   },
   hiddenMessageContainer: {
      opacity: 0.6,
   },
   hiddenMessage: {
      backgroundColor: '#f5f5f5',
      borderStyle: 'dashed',
      borderWidth: 1,
      borderColor: '#ccc',
   },
   hiddenText: {
      color: '#888',
      fontStyle: 'italic',
   },
   hiddenImage: {
      opacity: 0.5,
   },
});

export default CombinedCard;
